// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2Czkw","filesListContainer":"PosDisputesFiles_filesListContainer__1j6uq","filesButton":"PosDisputesFiles_filesButton__5A2SE"};